<div class="access-denied-wrapper">
  <mat-card class="access-denied-card">
    <mat-card-title class="custom-card-title">{{ 'COMMON.ACCESS_DENIED' | translate }}</mat-card-title>
    <p>{{ 'COMMON.ACCESS_DENIED_MESSAGE' | translate }}</p>
    @if (!isSupport) {
      <button type="button" mat-flat-button color="primary" routerLink="/dashboard">{{ 'COMMON.RETURN_TO_DASHBOARD' | translate }}</button>
    }
    @if (isSupport) {
      <button type="button" mat-flat-button color="primary" routerLink="/logs">{{ 'COMMON.RETURN_TO_LOGS' | translate }}</button>
    }
  </mat-card>
</div>
